import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import ViewItemListNormalizersResolver from "./ViewItemListNormalizersResolver";
export default class ViewItemListDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new ViewItemListNormalizersResolver());
        }
        return this.builderInstance;
    }
}
